var render = function render(){var _vm=this,_c=_vm._self._c;return _c('a-card',[_c('edit-modal')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }